module.exports = __webpack_public_path__ + "media/images/badges/cyclebar/red/RideClub_Milestones_App_100-Red-1e82c54fb8ee877e3acbb0d4c30eb930.png";